var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZyroFieldText',_vm._b({staticClass:"style-property",attrs:{"value":_vm.stylePropertyValue,"label":_vm.$attrs.label,"bold":false,"suffix":_vm.unit,"input-type":"number","maxlength":"5"},on:{"input":function($event){return _vm.setStyleProperty({
		element: _vm.element,
		property: _vm.property,
		value: ("" + ($event.target.value) + _vm.unit)
	})}}},'ZyroFieldText',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }